export default [
	{
		name: "login",
		path: "/login",
		component: () => import("@/view/login/Login"),
		meta: { layout: "BlankLayout", leftMenu: "false" }
    },
	{
		name: "login-callback",
		path: "/login-callback",
		component: () => import("@/view/login/LoginCallback"),
		meta: { layout: "BlankLayout", leftMenu: "false" }
    }
]